<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory')">Inventario y Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory/stock/list')">Stocks</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Detalle Stock</a>
    </div>

    <h1 class="ui header"><i class="icon edit outline"></i>
      <div class="content">Editar Stock</div>
    </h1>

    <h4 class="ui dividing header">Datos generales</h4>
    <div v-if="!data" class="ui active centered inline loader"></div>
    <div v-if="data" class="ui stackable two column divided grid container">
      <div class="row">
        <div class="column">
          <div class="form ui">
            <div class="field">
              <label>Nombre</label>
              <input type="text" v-model="data.stock_name">
            </div>
            <div class="field">
              <label>Máquinas</label>
              <sui-dropdown fluid multiple search selection id="idStockAptModel" :options="stockAptModelOptions"
                v-model="data.apt_models" />
            </div>
            <div v-if="data.n_slots" class="field">
              <label>Nº Slots</label>
              <input type="text" v-model="data.n_slots" readonly>
            </div>
          </div>
        </div>

        <div class="column">
          <div class="form ui">
            <div class="field">
              <label>Fabricante</label>
              <sui-dropdown fluid search selection id="idProvider" :options="providerOptions" v-model="data.provider" />
            </div>
            <div class="field">
              <label>Almacen</label>
              <input type="text" v-model="data.store_name" readonly>
            </div>
            <div class="field">
              <label>Total disponible</label>
              <input type="text" v-model="data.total_quantity" readonly>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="data" class="row">
      <div class="column">
        <div class="form ui">
          <div class="field" id="idBtns">
            <button id="idBtnEdit" class="ui button fluid" type="button" v-on:click="editStock">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <h4 v-if="data" class="ui dividing header">Datos por unidad</h4>
    <div v-if="data" class="ui stackable one column divided grid container">
      <div class="row">
        <div class="column">
          <form class="ui form">
            <table class="ui very basic compact selectable collapsing  table">
              <thead>
                <tr>
                  <th class="azpian">ID</th>
                  <th class="azpian">ID Fabricante</th>
                  <th class="azpian">Fecha Recepción</th>
                  <th class="azpian">Observaciones</th>
                  <th class="azpian">Reservada por</th>
                  <th class="azpian"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="val in rows" :key="val.id" :id="'idLine_' + val.id">
                  <td :id="'idPI_' + val.id"> {{ val.product_identifier }} </td>
                  <td :id="'idPIP_' + val.id"> {{ val.product_identifier_prov }} </td>
                  <td :id="'idReceiveDate_' + val.id"> {{ val.receive_date }} </td>
                  <td class="max-with-column" :id="'idObservations_' + val.id"> {{ val.observations }} </td>
                  <td :id="'idBookingBy_' + val.id"> {{ val.column_reservation_administrator_name }} </td>
                  <td class="right aligned">

                    <button :id="'idColumnBooking_' + val.id" type="button" class="ui basic button button-size"
                      v-if="val.column_reservation_id === null" v-on:click="columnBooking(val.id)">
                      Reservar
                    </button>
                    <div :id="'idEdit_' + val.id" class="ui basic button button-size"
                      v-on:click="viewProductDetail(val)">
                      Detalle
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
import BookingModal from '../../tools/BookingModal';
import { userNotification } from '../../tools/Utils';
export default {
  name: 'stockInfo',
  props: ['stock_id', 'store_id'],
  data() {
    return {
      rows: null,
      data: null,
      role: null,
      stockAptModelOptions: [],
      providerOptions: [],
    }
  },
  async created() {
    this.role = JSON.parse(localStorage.admin).role;
    if (this.role === 'master' || this.role === 'admin') {
      this.getDataFilters()
      this.getStockProductInfo()
    } else {
      this.$router.replace('/inventory')
    }
  },
  methods: {
    initializeComponente() {
      this.data = null
      this.rows = null
      this.getStockProductInfo()
    },

    async getStockProductInfo() {
      await hapiickApi().post('/v1/stocks/get-stock', {
        admin_id: JSON.parse(localStorage.admin).id,
        stock_id: this.stock_id,
        store_id: this.store_id
      })
        .then(response => {
          let stocks = JSON.parse(JSON.stringify(response.data.stocks));
          let stock_data = {}
          stock_data.id = stocks[0].id
          stock_data.stock_id = stocks[0].stock_id
          stock_data.stock_name = stocks[0].stock_name
          stock_data.store_name = stocks[0].store_name
          stock_data.n_slots = stocks[0].n_slots
          stock_data.total_quantity = 0
          stock_data.observations = stocks[0].observations
          stock_data.provider = stocks[0].provider
          stocks.forEach(a => {
            stock_data.total_quantity += a.quantity
          });
          stock_data.apt_models = stocks[0].apt_models.map((a => a.id))

          this.data = stock_data
          this.rows = stocks
        })
        .catch(() => {
          this.$swal({
            type: 'error',
            title: 'Error',
            text: 'Error al obtener los datos'
          });
        }
        )
    },
    async getDataFilters() {
      await hapiickApi().post('/v2/shipments/filters', {
        admin_id: JSON.parse(localStorage.admin).id,
        AptModel: true,
        Provider: true
      })
        .then(request => {
          this.fillStockAptModelOptions(JSON.parse(JSON.stringify(request.data.data.aptModels)))
          this.fillProviderOptions(JSON.parse(JSON.stringify(request.data.data.provider)))
        })
        .catch((error) => console.log(`Error getDataFilters: ${error}`))
    },
    fillStockAptModelOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.stockAptModelOptions.push({
          id: data[i].AptModel.id,
          key: data[i].AptModel.id,
          text: data[i].AptModel.name.toString(),
          value: data[i].AptModel.id,
        })
      }
    },
    fillProviderOptions(data) {
      for (let i = 0; i < data.length; i++) {
        this.providerOptions.push({
          id: data[i].Provider.id,
          key: data[i].Provider.id,
          text: data[i].Provider.name.toString(),
          value: data[i].Provider.id,
        })
      }
    },
    editStock() {
      let x = document.getElementById('idBtnEdit');
      x.classList.add("loading");
      x.disabled = true;

      let stock = {
        id: this.data.id,
        stock_id: this.data.stock_id,
        stock_name: this.data.stock_name,
        apt_models: this.data.apt_models,
        provider: this.data.provider,
      }
      stock.observations = (this.data.observations) ? this.data.observations : ''

      hapiickApi().post('/v1/stocks/edit', {
        admin_id: JSON.parse(localStorage.admin).id,
        stock
      })
        .then(req => {
          x.classList.remove("loading");
          x.disabled = false;

          if (req.data.status === 'OK') {
            this.$swal({
              type: 'success',
              title: 'Los datos se han guardado correctamente',
              showConfirmButton: false,
              timer: 2500
            })
          } else {
            this.$swal({
              type: 'error',
              title: 'Error',
              text: req.data.message
            })
          }
        })
        .catch(err => {
          this.$swal({
            type: 'error',
            title: 'Error',
            text: 'Error al guardar los datos'
          })
        })
    },

    viewProductDetail(val) {
      let routeData = this.$router.resolve('/inventory/stock/detail/' + val.id);
      window.open(routeData.href, '_blank');
    },

    async columnBooking(stock_product_id) {
      const success = await BookingModal.openModal(stock_product_id, JSON.parse(localStorage.admin).id)
      if (success === undefined) return

      if (success) {
        userNotification('success', 'Tu reserva se ha realizado correctamente', '', 2500)
        this.initializeComponente()
      } else {
        userNotification('error', 'Tu reserva no se ha podido realizar', '', 0)
      }
    },

    goTo(where) {
      this.$router.push(where)
    },
  },
}
</script>

<style scoped>
.cEdit {
  display: none;
}

#idBtns {
  display: flex;
  justify-content: center;
}

#idBtnEdit {
  background-color: black !important;
  color: white;
  width: 35%;
  margin-top: 30px;
}

.button-size {
  width: 120px
}

.max-with-column {
  max-width: 300px;
  word-wrap: break-word;
  white-space: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/Inventory/stockInfo.vue